export class Payment {
    id?: any;
    date?: string;
    username?: string; //first name + last name.. publisher
    method?: string;
    status?: string;
    amount?: number;
    currency?: string;
    exchange?: number;
    total?: number;
  }

  export class Profit {
      month?: string;
      value?: number;
  }

  export class Conversion {
      id?: any;             // Publisher id
      username?: string;    // firstname + lastname
      date?: string;
      status?: string;
      revenue?: number;
      visitor?: any;
      referrer?: any;
      campaignID?: any;
      campaign?: any;
  }

  export class PaymentsConfig {
    minAmount: any;
    payday: string;
    feeWired: any;
    feePayoneer: any;
    feePaypal: any;
  }
